module.exports = __webpack_public_path__ + "static/media/1014628.2acf7b9f.jpg";